var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFolderClose = function SvgFolderClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C62D1",
    d: "M8.73 6H4.313v12h15.375V8.681h-8.154zm3.926 4.385v1.99h1.98c.097 0 .177.073.177.164v.984c0 .09-.08.165-.176.165h-1.98v1.99a.165.165 0 0 1-.165.166h-.984a.167.167 0 0 1-.164-.167v-1.99h-1.98c-.097 0-.177-.074-.177-.164v-.984c0-.091.08-.164.176-.164h1.98v-1.99c0-.091.076-.166.165-.166h.984c.092 0 .164.075.164.166",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C62D1",
    d: "M20.625 6.994h-8.414l-2.75-2.63a.2.2 0 0 0-.128-.051H3.375a.75.75 0 0 0-.75.75v13.875c0 .414.335.75.75.75h17.25a.75.75 0 0 0 .75-.75V7.743a.75.75 0 0 0-.75-.75M19.688 18H4.313V6H8.73l2.804 2.681h8.153z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C62D1",
    d: "M11.344 10.385v1.99h-1.98c-.097 0-.177.073-.177.164v.984c0 .09.08.165.176.165h1.98v1.99c0 .09.076.166.165.166h.984a.165.165 0 0 0 .164-.167v-1.99h1.98c.097 0 .177-.074.177-.164v-.984c0-.091-.08-.164-.176-.164h-1.98v-1.99a.165.165 0 0 0-.165-.166h-.984a.167.167 0 0 0-.164.166"
  })));
};
export default SvgFolderClose;